<template>
    <div v-if="home" class="home">
      <span>약관 및 정책</span>
      <span class="title">파트너스 서비스 이용에 대한<br/> 약관 및 정책 확인이 가능해요</span>
      <div class="box" @click="change(1)">
          <span>서비스 이용약관</span>
          <img class="arrow" src="../../assets/icn.png" />
      </div>
      <div class="box" @click="change(2)">
          <span>개인정보 처리방침</span>
          <img class="arrow" src="../../assets/icn.png" />
      </div>
      <div class="box" @click="change(3)">
          <span>개인정보 수집 이용 제공 동의 항목 [의료기관]</span>
          <img class="arrow" src="../../assets/icn.png" />
      </div>
      <div class="box" @click="change(4)">
          <span>개인정보 수집 이용 제공 동의 항목 [비의료기관]</span>
          <img class="arrow" src="../../assets/icn.png" />
      </div>
      <div class="box" @click="change(5)">
          <span>개인정보 위수탁 계약서</span>
          <img class="arrow" src="../../assets/icn.png" />
      </div>
      <div class="box" @click="change(6)">
          <span>개인정보 마케팅 활용</span>
          <img class="arrow" src="../../assets/icn.png" />
      </div>
      <div class="box" @click="change(7)">
          <span>광고성 정보 수신</span>
          <img class="arrow" src="../../assets/icn.png" />
      </div>
    </div>
    <router-view v-else />
  </template>
  
  <script>
  
  
  export default {
      name: 'policy',
      data: function()
      {
          return {
              home: true,
              contents: null
          }
      },
      mounted: function()
      {
          if(this.$route.fullPath !== '/partners')
          {
              this.home = false;
          }      
      },  
      methods: {
          change: function(view)
          {
              this.home = false;
  
              if(view === 1)
              {
                  this.$router.push({path: '/partners/terms'})
              }
              else if(view === 2)
              {
                  this.$router.push({path: '/partners/privacy'})
              }
              else if(view === 3)
              {
                  this.$router.push({path: '/partners/use?is_medical=true'})
              }
              else if(view === 4)
              {
                  this.$router.push({path: '/partners/use?is_medical=false'})
              }
              else if(view === 5)
              {
                  this.$router.push({path: '/partners/contract'})
              }
              else if(view === 6)
              {
                  this.$router.push({path: '/partners/marketing'})
              }
              else if(view === 7)
              {
                  this.$router.push({path: '/partners/advertisement'})
              }
          }
      },
      watch: {
          $route(to, from) {
  
              if(from.fullPath !== '/partners')
              {
                
                  this.home = true;
                  
              }
              else
              {
                  this.home = false;
              }
          }
      }
  }
  </script>
  
  <style scoped>
  .home {
          display: flex;
          flex-direction: column;
      }
      .title {
          font-size: 20px;
          font-weight: bold;
          margin-top: 30px;
          margin-bottom: 30px;
      }
      .box {
          height: 65px;
          border-bottom: 1px solid #E8EAEE;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
      }
      .arrow {
          width: 10px;
      }
  </style>


// WEBPACK FOOTER //
// src/pages/partners/Policy.vue